import { validationMixin } from 'vuelidate'

export default {
    mixins: [validationMixin],
    methods: {
        validate() {
            this.$v.$touch()
            return !this.$v.$invalid
        },
        validateField(fieldName) {
            return this.$v[fieldName].$dirty ? !this.$v[fieldName].$invalid : null
        },
    },
}
